import React from 'react';
import PropTypes from 'prop-types';
import styles from './mobileNavButton.css';

const MobileNavButton = ({ active, click }) => {
  return (
    <div className={styles.wrapper}>
      <button className={styles.button} onClick={click} type="button">
        Menu {active ? '[–]' : '[+]'}
      </button>
    </div>
  );
};

MobileNavButton.defaultProps = {
  active: false,
};

MobileNavButton.propTypes = {
  active: PropTypes.bool,
  click: PropTypes.func.isRequired,
};

export default MobileNavButton;
